import { render, staticRenderFns } from "./IotDevicePortConfigDialog.vue?vue&type=template&id=a1187486&scoped=true"
import script from "./IotDevicePortConfigDialog.vue?vue&type=script&lang=ts"
export * from "./IotDevicePortConfigDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1187486",
  null
  
)

export default component.exports